import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a0de64dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border-0 rounded right-0 top-0 overflow-y-auto overflow-x-hidden scrollable-container z-60 fixed flex flex-col w-full max-w-xl bg-white h-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-40 fixed inset-0 z-55 bg-black" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "header", {}, undefined, true),
        _hoisted_2,
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ]),
    _hoisted_3
  ], 64))
}